import NoteModuleProviderModule from '@/modules/note/NoteModuleProvider'
import LibreModuleProviderModule from '@/modules/libre/LibreModuleProvider'
import EducationModuleProviderModule from '@/modules/education/EducationModuleProvider'
import { IModule } from '@/contracts/core/module/interface/IModule'

function getModulesList(): IModule[] {
  return [
    NoteModuleProviderModule(),
    LibreModuleProviderModule(),
    EducationModuleProviderModule(),
  ]
}

class ModulesReg {
  private modules: { [key: string]: IModule } = {}

  private static instance: ModulesReg

  static getInstance(): ModulesReg {

    if (!ModulesReg.instance) {
      ModulesReg.instance = new ModulesReg()

      // регистрируем модули
      getModulesList().forEach((module) => {
        ModulesReg.instance.regModule(module)
      })
    }
    return ModulesReg.instance
  }

  getModule(moduleId: string): IModule {
    const key = `${moduleId}`
    if (this.modules[key] === undefined) {
      throw new Error(`Module ${moduleId} not found.`)
    }
    return this.modules[key]
  }

  regModule(module: IModule): void {
    const moduleId = module.getMeta().getModuleId()

    if (this.modules[`${moduleId}`] !== undefined) {
      throw new Error(`Module ${moduleId} already registered.`)
    }
    this.modules[`${moduleId}`] = module
  }
}

export default function (): ModulesReg {
  return ModulesReg.getInstance()
}
